(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9590,9635],{

/***/ 65576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Box_Box; }
});

// UNUSED EXPORTS: styleFunction

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(74902);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/merge.js
var merge = __webpack_require__(19668);
;// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/styleFunctionSx.js






function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}

var warnedOnce = false;

function styleFunctionSx(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var output = styleFunction(props);

    if (props.css) {
      return (0,esm_extends/* default */.Z)({}, (0,merge/* default */.Z)(output, styleFunction((0,esm_extends/* default */.Z)({
        theme: props.theme
      }, props.css))), omit(props.css, [styleFunction.filterProps]));
    }

    if (props.sx) {
      return (0,esm_extends/* default */.Z)({}, (0,merge/* default */.Z)(output, styleFunction((0,esm_extends/* default */.Z)({
        theme: props.theme
      }, props.sx))), omit(props.sx, [styleFunction.filterProps]));
    }

    return output;
  };

  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ['css', 'sx'].concat((0,toConsumableArray/* default */.Z)(styleFunction.filterProps));
  return newStyleFunction;
}
/**
 *
 * @deprecated
 * The css style function is deprecated. Use the `styleFunctionSx` instead.
 */


function css(styleFunction) {
  if (false) {}

  return styleFunctionSx(styleFunction);
}
/* harmony default export */ var esm_styleFunctionSx = (styleFunctionSx);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/compose.js
var compose = __webpack_require__(85680);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/borders.js
var borders = __webpack_require__(99424);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/display.js
var display = __webpack_require__(50962);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/flexbox.js
var flexbox = __webpack_require__(23633);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/style.js
var style = __webpack_require__(8245);
;// CONCATENATED MODULE: ./node_modules/@material-ui/system/esm/grid.js


var gridGap = (0,style/* default */.Z)({
  prop: 'gridGap'
});
var gridColumnGap = (0,style/* default */.Z)({
  prop: 'gridColumnGap'
});
var gridRowGap = (0,style/* default */.Z)({
  prop: 'gridRowGap'
});
var gridColumn = (0,style/* default */.Z)({
  prop: 'gridColumn'
});
var gridRow = (0,style/* default */.Z)({
  prop: 'gridRow'
});
var gridAutoFlow = (0,style/* default */.Z)({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = (0,style/* default */.Z)({
  prop: 'gridAutoColumns'
});
var gridAutoRows = (0,style/* default */.Z)({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = (0,style/* default */.Z)({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = (0,style/* default */.Z)({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = (0,style/* default */.Z)({
  prop: 'gridTemplateAreas'
});
var gridArea = (0,style/* default */.Z)({
  prop: 'gridArea'
});
var grid = (0,compose/* default */.Z)(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* harmony default export */ var esm_grid = (grid);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/positions.js
var positions = __webpack_require__(43939);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/palette.js
var palette = __webpack_require__(5164);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/shadows.js
var shadows = __webpack_require__(70958);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/sizing.js
var sizing = __webpack_require__(86801);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/spacing.js + 1 modules
var spacing = __webpack_require__(27122);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/typography.js
var typography = __webpack_require__(29560);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/makeStyles.js + 4 modules
var makeStyles = __webpack_require__(11719);
;// CONCATENATED MODULE: ./node_modules/@material-ui/styles/esm/styled/styled.js









function styled_omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
} // styled-components's API removes the mapping between components and styles.
// Using components as a low-level styling construct can be simpler.


function styled_styled(Component) {
  var componentCreator = function componentCreator(style) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var name = options.name,
        stylesOptions = (0,objectWithoutProperties/* default */.Z)(options, ["name"]);

    if (false) {}

    var classNamePrefix = name;

    if (false) { var displayName; }

    var stylesOrCreator = typeof style === 'function' ? function (theme) {
      return {
        root: function root(props) {
          return style((0,esm_extends/* default */.Z)({
            theme: theme
          }, props));
        }
      };
    } : {
      root: style
    };
    var useStyles = (0,makeStyles/* default */.Z)(stylesOrCreator, (0,esm_extends/* default */.Z)({
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var filterProps;
    var propTypes = {};

    if (style.filterProps) {
      filterProps = style.filterProps;
      delete style.filterProps;
    }
    /* eslint-disable react/forbid-foreign-prop-types */


    if (style.propTypes) {
      propTypes = style.propTypes;
      delete style.propTypes;
    }
    /* eslint-enable react/forbid-foreign-prop-types */


    var StyledComponent = /*#__PURE__*/react.forwardRef(function StyledComponent(props, ref) {
      var children = props.children,
          classNameProp = props.className,
          clone = props.clone,
          ComponentProp = props.component,
          other = (0,objectWithoutProperties/* default */.Z)(props, ["children", "className", "clone", "component"]);

      var classes = useStyles(props);
      var className = (0,clsx_m/* default */.Z)(classes.root, classNameProp);
      var spread = other;

      if (filterProps) {
        spread = styled_omit(spread, filterProps);
      }

      if (clone) {
        return /*#__PURE__*/react.cloneElement(children, (0,esm_extends/* default */.Z)({
          className: (0,clsx_m/* default */.Z)(children.props.className, className)
        }, spread));
      }

      if (typeof children === 'function') {
        return children((0,esm_extends/* default */.Z)({
          className: className
        }, spread));
      }

      var FinalComponent = ComponentProp || Component;
      return /*#__PURE__*/react.createElement(FinalComponent, (0,esm_extends/* default */.Z)({
        ref: ref,
        className: className
      }, spread), children);
    });
     false ? 0 : void 0;

    if (false) {}

    hoist_non_react_statics_cjs_default()(StyledComponent, Component);
    return StyledComponent;
  };

  return componentCreator;
}
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/defaultTheme.js
var defaultTheme = __webpack_require__(99700);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/styles/styled.js




var styled = function styled(Component) {
  var componentCreator = styled_styled(Component);
  return function (style, options) {
    return componentCreator(style, (0,esm_extends/* default */.Z)({
      defaultTheme: defaultTheme/* default */.Z
    }, options));
  };
};

/* harmony default export */ var styles_styled = (styled);
;// CONCATENATED MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js


var styleFunction = esm_styleFunctionSx((0,compose/* default */.Z)(borders/* default */.ZP, display/* default */.ZP, flexbox/* default */.ZP, esm_grid, positions/* default */.ZP, palette/* default */.ZP, shadows/* default */.Z, sizing/* default */.ZP, spacing/* default */.Z, typography/* default */.ZP));
/**
 * @ignore - do not document.
 */

var Box = styles_styled('div')(styleFunction, {
  name: 'MuiBox'
});
/* harmony default export */ var Box_Box = (Box);

/***/ }),

/***/ 55517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1591);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59693);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_1__/* .alpha */ .Fq)(theme.palette.divider, 0.08)
    },

    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      height: '100%',
      width: 1
    },

    /* Styles applied to the root element if `flexItem={true}`. */
    flexItem: {
      alignSelf: 'stretch',
      height: 'auto'
    }
  };
};
var Divider = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Divider(props, ref) {
  var _props$absolute = props.absolute,
      absolute = _props$absolute === void 0 ? false : _props$absolute,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'hr' : _props$component,
      _props$flexItem = props.flexItem,
      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
      _props$light = props.light,
      light = _props$light === void 0 ? false : _props$light,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$role = props.role,
      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
    role: role,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, {
  name: 'MuiDivider'
})(Divider));

/***/ }),

/***/ 89659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(86010);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93871);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1591);
/* harmony import */ var _utils_useIsFocusVisible__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24896);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17294);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);











var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `underline="none"`. */
  underlineNone: {
    textDecoration: 'none'
  },

  /* Styles applied to the root element if `underline="hover"`. */
  underlineHover: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },

  /* Styles applied to the root element if `underline="always"`. */
  underlineAlways: {
    textDecoration: 'underline'
  },
  // Same reset as ButtonBase.root

  /* Styles applied to the root element if `component="button"`. */
  button: {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$focusVisible': {
      outline: 'auto'
    }
  },

  /* Pseudo-class applied to the root element if the link is keyboard focused. */
  focusVisible: {}
};
var Link = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Link(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'a' : _props$component,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      TypographyClasses = props.TypographyClasses,
      _props$underline = props.underline,
      underline = _props$underline === void 0 ? 'hover' : _props$underline,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'inherit' : _props$variant,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);

  var _useIsFocusVisible = (0,_utils_useIsFocusVisible__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  var handlerRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ref, focusVisibleRef);

  var handleBlur = function handleBlur(event) {
    if (focusVisible) {
      onBlurVisible();
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(classes.root, classes["underline".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
    classes: TypographyClasses,
    color: color,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    variant: variant
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(styles, {
  name: 'MuiLink'
})(Link));

/***/ }),

/***/ 38579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63786);


/* harmony default export */ __webpack_exports__["Z"] = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
}), 'ArrowForwardIos'));

/***/ }),

/***/ 58670:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hub/[category]/[slug]",
      function () {
        return __webpack_require__(50527);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var hub_helpers_contentful__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55352);






function ContentfulImage(_param) {
    var src = _param.src, width = _param.width, height = _param.height, _layout = _param.layout, layout = _layout === void 0 ? "responsive" : _layout, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "src",
        "width",
        "height",
        "layout",
        "alt"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        alt: alt,
        src: (0,hub_helpers_contentful__WEBPACK_IMPORTED_MODULE_3__/* .getContentfulImageUrl */ .l)(src),
        width: width,
        height: height,
        layout: layout,
        objectFit: "cover",
        quality: "85"
    }, restProps));
}
/* harmony default export */ __webpack_exports__["default"] = (ContentfulImage);


/***/ }),

/***/ 50527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(74129);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Divider/Divider.js
var Divider = __webpack_require__(55517);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(4024);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(38579);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/lodash/truncate.js
var truncate = __webpack_require__(39138);
var truncate_default = /*#__PURE__*/__webpack_require__.n(truncate);
// EXTERNAL MODULE: ./src/hub/components/ContentfulImage.js
var ContentfulImage = __webpack_require__(79635);
;// CONCATENATED MODULE: ./src/hub/components/ArticleCard.js




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  color: currentColor;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        "px;\n  height: 100%;\n  width: 100%;\n  min-height: 140px;\n  position: relative;\n  cursor: pointer;\n\n  img {\n    transition: transform 0.5s ease, filter 0.5s ease;\n  }\n\n  &:hover img {\n    filter: brightness(0.9);\n    transform: scale(1.1);\n  }\n\n  &:hover .article-title {\n    text-decoration: underline;\n  }\n\n  ",
        " {\n    flex-direction: row;\n    gap: ",
        "px;\n    height: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  font-weight: 400;\n  color: #3c4340;\n  line-height: 94%;\n  letter-spacing: 0.4px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  min-height: 200px;\n\n  ",
        " {\n    max-width: 200px;\n    width: 35%;\n    min-height: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n  width: 100%;\n\n  ",
        " {\n    width: 65%;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








function ArticleCard(_param) {
    var title = _param.title, description = _param.description, hubslug = _param.hubslug, postCategory = _param.postCategory, heroImage = _param.heroImage, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "description",
        "hubslug",
        "postCategory",
        "heroImage"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)("hub").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/hub/".concat(hubslug),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            as: "a"
        }, restProps), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulImage["default"], {
                        src: heroImage,
                        layout: "fill",
                        objectFit: "cover",
                        alt: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                    children: [
                        postCategory && /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryLabel, {
                            pb: 1.5,
                            children: [
                                t("hub:post.categoryLabel"),
                                ": ",
                                postCategory.title
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            as: "header",
                            mb: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "h5",
                                component: "h2",
                                fontSIze: "18px",
                                color: "textPrimary",
                                className: "article-title",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "body1",
                                fontSize: "16px",
                                mb: 0,
                                children: truncate_default()(description, {
                                    length: 80
                                })
                            })
                        })
                    ]
                })
            ]
        }))
    });
}
var CardWrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
var CategoryLabel = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject1());
var ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
var ContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), function(props) {
    return props.theme.breakpoints.up("sm");
});
/* harmony default export */ var components_ArticleCard = (ArticleCard);

// EXTERNAL MODULE: ./src/hub/components/ArticlePage/SignupForm.tsx + 1 modules
var SignupForm = __webpack_require__(95839);
;// CONCATENATED MODULE: ./src/hub/components/ProgressBar.js

function ProgressBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 4px;\n  position: fixed;\n  z-index: ",
        ";\n"
    ]);
    ProgressBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProgressBar_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 4px;\n  background: ",
        ";\n  width: 0%;\n"
    ]);
    ProgressBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



function ProgressBar(param) {
    var contentRef = param.contentRef;
    var progressBarRef = (0,react.useRef)(undefined);
    (0,react.useEffect)(function() {
        if (true) {
            var scrolling = function scrolling() {
                var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
                var height = contentRef.current ? contentRef.current.scrollHeight - document.documentElement.clientHeight + 80 : document.documentElement.scrollHeight - document.documentElement.clientHeight;
                var scrolled = winScroll / height * 100;
                if (progressBarRef.current) return progressBarRef.current.style.width = scrolled + "%";
            };
            window.addEventListener("scroll", scrolling);
            return function() {
                window.removeEventListener("scroll", scrolling);
            };
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar, {
            ref: progressBarRef
        })
    });
}
var Container = styled_components_browser_esm/* default.div */.ZP.div(ProgressBar_templateObject(), function(props) {
    return props.theme.zIndex.appBar - 1;
});
var Bar = styled_components_browser_esm/* default.div */.ZP.div(ProgressBar_templateObject1(), function(props) {
    return props.theme.palette.primary.main;
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Facebook.js
var Facebook = __webpack_require__(83792);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Twitter.js
var Twitter = __webpack_require__(44704);
;// CONCATENATED MODULE: ./src/hub/helpers/post.js
var FACEBOOK_SHARE_URL = "https://www.facebook.com/sharer.php";
var TWITTER_SHARE_URL = "https://twitter.com/share";
var facebookShareUrl = function(param) {
    var url = param.url;
    return "".concat(FACEBOOK_SHARE_URL, "?u=").concat(url);
};
var twitterShareUrl = function(param) {
    var url = param.url, text = param.text;
    return "".concat(TWITTER_SHARE_URL, "?text=").concat(text, "&url=").concat(url);
};

;// CONCATENATED MODULE: ./src/hub/components/SocialButtons.tsx

function SocialButtons_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: flex;\n  gap: 12px;\n  flex-direction: ",
        ";\n\n  ",
        " {\n    flex-direction: ",
        ";\n  }\n"
    ]);
    SocialButtons_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SocialButtons_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  height: 29px;\n  width: 29px;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n  border-radius: 500px;\n\n  svg {\n    height: 20px;\n  }\n\n  ",
        " {\n    height: 35px;\n    width: 35px;\n\n    svg {\n      height: 25px;\n    }\n  }\n"
    ]);
    SocialButtons_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var SocialButtons = function(param) {
    var socialMediaUrl = param.socialMediaUrl, title = param.title, direction = param.direction;
    var t = (0,useTranslation/* useTranslation */.$)("hub").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SocialButtonList, {
        $direction: direction,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                    title: t("post.shareOnFacebookTitle"),
                    placement: "top",
                    arrow: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialButtonLink, {
                        href: facebookShareUrl({
                            url: socialMediaUrl
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {
                            htmlColor: "white",
                            fontSize: "small"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                    title: t("post.shareOnTwitterTitle"),
                    placement: "top",
                    arrow: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialButtonLink, {
                        href: twitterShareUrl({
                            url: socialMediaUrl,
                            text: title
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {
                            htmlColor: "white",
                            fontSize: "small"
                        })
                    })
                })
            })
        ]
    });
};
var SocialButtonList = styled_components_browser_esm/* default.ul */.ZP.ul(SocialButtons_templateObject(), function(param) {
    var $direction = param.$direction;
    return $direction || "row";
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var $direction = param.$direction;
    return $direction || "column";
});
var SocialButtonLink = styled_components_browser_esm/* default.a */.ZP.a(SocialButtons_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary.light;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
/* harmony default export */ var components_SocialButtons = (SocialButtons);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@contentful/rich-text-types/dist/rich-text-types.es5.js
var rich_text_types_es5 = __webpack_require__(80865);
;// CONCATENATED MODULE: ./src/hub/components/TableOfContents/utils.tsx


function utils_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  scroll-margin-top: ",
        ";\n"
    ]);
    utils_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var H2 = "heading-2";
var H3 = "heading-3";
var mapPostIntoHeadingTree = function(post) {
    var headingNodes = post.body.content.filter(function(node) {
        return [
            H2,
            H3
        ].includes(node.nodeType);
    });
    var flatHeadings = headingNodes.map(function(node) {
        return {
            level: getNumberFromString(node.nodeType),
            text: getTextFromHeadingNode(node) || "",
            id: getIdFromHeadingNode(node)
        };
    });
    var headingTree = [];
    flatHeadings.forEach(function(param, index) {
        var level = param.level, text = param.text, id = param.id;
        if (level === 2) {
            var remainingItems = flatHeadings.slice(index + 1);
            var indexOfNextMainHeading = remainingItems.findIndex(function(node) {
                return node.level === 2;
            });
            var children = remainingItems.slice(0, indexOfNextMainHeading);
            headingTree.push({
                level: 2,
                text: text,
                children: children,
                id: id
            });
        }
    });
    return headingTree;
};
var _obj;
/**
 * `renderNode` options for the `documentToReactComponents` function.
 * It adds ids to h2 and h3 headings, so they can be anchored to
 *
 * Example usage:
 * ```jsx
 * return documentToReactComponents(document, {renderNode: anchorHeaderNodeOptions})
 * ```
 *
 */ var anchorableHeaderOptions = {
    renderNode: (_obj = {}, // eslint-disable-next-line react/display-name
    (0,_define_property/* default */.Z)(_obj, rich_text_types_es5/* BLOCKS.HEADING_2 */.RG.HEADING_2, function(node, children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingWithAnchorOffset, {
            as: "h2",
            id: getIdFromHeadingNode(node),
            children: children
        });
    }), // eslint-disable-next-line react/display-name
    (0,_define_property/* default */.Z)(_obj, rich_text_types_es5/* BLOCKS.HEADING_3 */.RG.HEADING_3, function(node, children) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadingWithAnchorOffset, {
            as: "h3",
            id: getIdFromHeadingNode(node),
            children: children
        });
    }), _obj)
};
/**
 * Approximate height of the header on the top of the page
 */ var APPROX_HEADER_OFFSET = "110px";
var HeadingWithAnchorOffset = styled_components_browser_esm/* default.h2 */.ZP.h2(utils_templateObject(), APPROX_HEADER_OFFSET);
function getNumberFromString(str) {
    return parseInt(str.replace(/^\D+/g, ""));
}
function getTextFromHeadingNode(node) {
    var ref;
    var content = (ref = node.content) === null || ref === void 0 ? void 0 : ref[0];
    if ("value" in content) {
        return content.value;
    }
    return "";
}
function getIdFromHeadingNode(node) {
    var text = getTextFromHeadingNode(node);
    return text.trim().replace(/\s/g, "_") // replace white space with underscore
    .replace(/\W+/g, "") // remove special characters
    .toLowerCase();
}

;// CONCATENATED MODULE: ./src/hub/components/TableOfContents/index.js




function TableOfContents_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  margin: 0;\n  padding: 0;\n\n  ul {\n    margin-left: 1rem;\n  }\n"
    ]);
    TableOfContents_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TableOfContents_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  color: inherit;\n  font-size: 14px;\n"
    ]);
    TableOfContents_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TableOfContents_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-decoration: none;\n  font-size: 12px;\n"
    ]);
    TableOfContents_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TableOfContents_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  list-style-type: none;\n  margin-top: 1rem;\n"
    ]);
    TableOfContents_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f8f8f8;\n  padding: 1rem;\n  flex-grow: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






function TableOfContents(_param) {
    var headings = _param.headings, boxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "headings"
    ]);
    var t = (0,useTranslation/* useTranslation */.$)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WrapperBox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        as: "nav"
    }, boxProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContentsTitle, {
                variant: "h5",
                component: "h3",
                children: t("tableOfContents.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
                role: "list",
                children: headings.map(function(param) {
                    var level = param.level, text = param.text, children = param.children, id = param.id;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledListItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyMainHeading, {
                                variant: "h5",
                                component: "a",
                                href: "#".concat(id),
                                gutterBottom: true,
                                children: text
                            }),
                            children.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledList, {
                                role: "list",
                                children: children.map(function(child) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledListItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographySecondaryHeading, {
                                            href: "#".concat(child.id),
                                            component: "a",
                                            children: child.text
                                        })
                                    }, "".concat(child.level, "_").concat(child.id));
                                })
                            }) : null
                        ]
                    }, "".concat(level, "_").concat(id));
                })
            })
        ]
    }));
}
var StyledList = styled_components_browser_esm/* default.ul */.ZP.ul(TableOfContents_templateObject());
var TypographyMainHeading = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(TableOfContents_templateObject1());
var TypographySecondaryHeading = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(TableOfContents_templateObject2(), function(props) {
    return props.theme.palette.text.secondary;
});
var StyledListItem = styled_components_browser_esm/* default.li */.ZP.li(TableOfContents_templateObject3());
var WrapperBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject4());
var TableOfContentsTitle = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject5(), function(props) {
    return props.theme.palette.primary.main;
});

// EXTERNAL MODULE: ./src/hub/helpers/contentful.tsx
var contentful = __webpack_require__(55352);
;// CONCATENATED MODULE: ./src/hub/styles.js

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  padding: ",
        ";\n  background: ",
        ";\n  border-radius: 500px;\n  font-size: 12px;\n  font-weight: bold;\n  margin-right: ",
        "px;\n  margin-bottom: ",
        "px;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Tag = styled_components_browser_esm/* default.span */.ZP.span(styles_templateObject(), function(props) {
    return props.theme.spacing(0.5, 2);
}, function(props) {
    return props.theme.palette.grey[100];
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(1);
});

// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./src/shared/components/Dots.tsx
var Dots = __webpack_require__(90848);
// EXTERNAL MODULE: ./src/shared/components/FlexBox.tsx
var FlexBox = __webpack_require__(85249);
// EXTERNAL MODULE: ./src/shared/helpers/dates.js
var dates = __webpack_require__(47004);
// EXTERNAL MODULE: ./src/shared/hooks/usePagination.ts + 1 modules
var usePagination = __webpack_require__(98038);
// EXTERNAL MODULE: ./src/shared/layouts/MainLayout.tsx + 1 modules
var MainLayout = __webpack_require__(89452);
// EXTERNAL MODULE: ./src/static_pages/components/FooterLinks.tsx
var FooterLinks = __webpack_require__(6029);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/components/SidebarCTA.js
var SidebarCTA = __webpack_require__(84332);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var components_Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/hub/components/ArticlePage/index.tsx



function ArticlePage_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  margin: 0;\n  ul {\n    padding-left: 0;\n    list-style: none;\n\n    li {\n      height: 100%;\n    }\n  }\n"
    ]);
    ArticlePage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ArticlePage_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transform: scaleX(-1);\n"
    ]);
    ArticlePage_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ArticlePage_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  transition: background-color 0.2s ease-out;\n  height: 42px;\n  width: 42px;\n  border-radius: 4px;\n  padding: ",
        ";\n  :hover {\n    background-color: ",
        ";\n  }\n  :active {\n    background-color: ",
        ";\n  }\n"
    ]);
    ArticlePage_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ArticlePage_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n"
    ]);
    ArticlePage_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ArticlePage_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: inherit;\n  padding: ",
        ";\n  font-weight: 500;\n  line-height: ",
        "px;\n  letter-spacing: 0.15px;\n  font-size: 14px;\n"
    ]);
    ArticlePage_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ArticlePage_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    ArticlePage_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  background: ",
        ";\n  text-align: center;\n  border-radius: 8px;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}





























var POST_SUGGESTIONS_PER_SLIDE = 4;
function ArticlePage(param) {
    var post = param.post, headings = param.headings, ratings = param.ratings;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var t = (0,useTranslation/* useTranslation */.$)("hub").t;
    var assetOptions = (0,contentful/* embeddedAssetOptions */.k)();
    var isMobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var body = (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(post.body, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, assetOptions), {
        renderNode: (0,_object_spread/* default */.Z)({}, assetOptions.renderNode, anchorableHeaderOptions.renderNode)
    }));
    var locale = (0,router.useRouter)().locale;
    var contentRef = (0,react.useRef)(null);
    var _targetAudience = post.targetAudience, targetAudience = _targetAudience === void 0 ? "customer" : _targetAudience;
    var socialMediaUrl = react.useMemo(function() {
        return "".concat("https://www.heycater.com", "/hub/").concat(post.postCategory.slug, "/").concat(post.slug);
    }, [
        post
    ]);
    var postSuggestionSlides = (0,usePagination/* usePagination */.h)(post.suggestedArticles, {
        pageSize: POST_SUGGESTIONS_PER_SLIDE
    });
    var hasPostSuggestionSlider = !isMobile && postSuggestionSlides.pageCount > 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.Z, {
        ratings: ratings,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: post.metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: post.metaDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "".concat(post.title, " | heycater!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: post.metaDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "article"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "".concat((0,contentful/* getContentfulImageUrl */.l)(post.heroImage), "?w=1200&h=630&fit=fill")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProgressBar, {
                contentRef: contentRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: contentRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                    mt: isMobile ? 0 : 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Container/* default */.Z, {
                            disableGutters: isMobile,
                            size: "sm",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                borderRadius: isMobile ? undefined : "8px",
                                overflow: "hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulImage["default"], {
                                    src: post.heroImage,
                                    priority: true,
                                    quality: 90,
                                    width: 890,
                                    height: 480,
                                    layout: "responsive"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Container/* default */.Z, {
                            size: "xs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SidebarCTA/* AreaWithSidebarCTA */.U, {
                                title: post.buttonCta,
                                subtitle: post.buttonCtaSubtitle ? post.buttonCtaSubtitle : t("post.buttonSubtitle"),
                                ctaText: post.buttonCtaCopy || t("post.footerCTAButtonLabel"),
                                url: post.buttonUrl,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                        display: "flex",
                                        mt: 2,
                                        justifyContent: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Typography */.ZT, {
                                                variant: "caption",
                                                color: "textSecondary",
                                                component: "p",
                                                children: [
                                                    t("post.categoryLabel"),
                                                    ":",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        passHref: true,
                                                        href: "/hub/".concat(post.postCategory.slug),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, {
                                                            children: post.postCategory.category
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                variant: "caption",
                                                color: "textSecondary",
                                                component: "p",
                                                children: (0,dates/* formatDate */.p6)(post.updatedAt, locale)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        mt: 2,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                            variant: "h3",
                                            fontSize: isMobile ? "28px" : "40px",
                                            component: "h1",
                                            children: post.title
                                        })
                                    }),
                                    post.author && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* default */.Z, {
                                        mt: 3,
                                        mb: 2,
                                        alignItems: "center",
                                        gap: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                                position: "relative",
                                                borderRadius: "500px",
                                                overflow: "hidden",
                                                width: "65px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: "https:".concat(post.author.avatar.file.url),
                                                    width: (ref = post.author.avatar.file.details.image) === null || ref === void 0 ? void 0 : ref.width,
                                                    height: (ref1 = post.author.avatar.file.details.image) === null || ref1 === void 0 ? void 0 : ref1.height,
                                                    layout: "responsive",
                                                    objectFit: "cover",
                                                    alt: ""
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* default */.Z, {
                                                flexDirection: "column",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                        fontWeight: "500",
                                                        children: t("post.author.".concat(isMobile ? "brief" : "verbose"), {
                                                            author: post.author.name
                                                        })
                                                    }),
                                                    ((ref2 = post.author) === null || ref2 === void 0 ? void 0 : ref2.description) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyAuthorDescription, {
                                                        fontWeight: "500",
                                                        children: post.author.description
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* default */.Z, {
                                        gap: isMobile ? 2 : 5,
                                        flexDirection: "row",
                                        mt: 4,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableOfContents, {
                                                mb: isMobile ? 1.2 : 4,
                                                headings: headings
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SocialButtons, {
                                                direction: "column",
                                                socialMediaUrl: socialMediaUrl,
                                                title: post.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                        mb: 6,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                                mb: 4,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                    variant: "body1",
                                                    children: body
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                                children: post.tags.map(function(tag) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                                        children: tag
                                                    }, tag);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        mb: {
                                            xs: 3,
                                            sm: 2
                                        },
                                        mt: {
                                            xs: 2,
                                            sm: 3
                                        },
                                        py: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupForm/* default */.Z, {
                                            title: (post === null || post === void 0 ? void 0 : (ref3 = post.contactForm) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : ref4.title) || t("signUpForm.blogPosts.".concat(targetAudience.toLowerCase(), "Messages.title")),
                                            subTitle: ((ref5 = post.contactForm) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : ref6.subtitle) || t("signUpForm.blogPosts.".concat(targetAudience.toLowerCase(), "Messages.subTitle")),
                                            imageSrc: ((ref7 = post.contactForm) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.fields) === null || ref8 === void 0 ? void 0 : ref8.image) ? (0,contentful/* getContentfulImageUrl */.l)(post.contactForm.fields.image) : undefined,
                                            successFeedback: post === null || post === void 0 ? void 0 : (ref9 = post.contactForm) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fields) === null || ref10 === void 0 ? void 0 : ref10.successFeedback,
                                            buttonText: post === null || post === void 0 ? void 0 : (ref11 = post.contactForm) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.fields) === null || ref12 === void 0 ? void 0 : ref12.buttonText,
                                            contactListId: (ref13 = post.contactForm) === null || ref13 === void 0 ? void 0 : ref13.fields.contactList.fields.id
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        mb: 8,
                                        mt: 4,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            post.buttonCta.length > 0 && post.buttonUrl.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCTA, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Container/* default */.Z, {
                    size: "sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            mb: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "h4",
                                component: "h2",
                                align: "center",
                                gutterBottom: true,
                                children: post.buttonCta
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zx, {
                            rounded: true,
                            size: "lg",
                            component: "a",
                            passHref: true,
                            href: post.buttonUrl,
                            target: "_blank",
                            rel: "noopener",
                            id: "hub-footer-cta",
                            children: post.buttonCtaCopy || t("post.footerCTAButtonLabel")
                        })
                    ]
                })
            }),
            ((ref14 = postSuggestionSlides.currentPage) === null || ref14 === void 0 ? void 0 : ref14.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestedArticlesWrapper, {
                as: "section",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_Container/* default */.Z, {
                    size: "lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            pb: 6,
                            textAlign: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "h3",
                                component: "h2",
                                gutterBottom: true,
                                children: t("post.suggestedArticlesLabel")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexBox/* default */.Z, {
                            children: [
                                hasPostSuggestionSlider && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* default */.Z, {
                                    alignItems: "center",
                                    mr: 5,
                                    ml: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButton, {
                                        onClick: postSuggestionSlides.prev,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack, {
                                            fontSize: "large"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        component: "ul",
                                        container: true,
                                        spacing: 3,
                                        children: postSuggestionSlides.currentPage.map(function(suggestedArticle) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                component: "li",
                                                item: true,
                                                xs: 12,
                                                sm: 12,
                                                md: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArticleCard, (0,_object_spread/* default */.Z)({}, suggestedArticle))
                                            }, suggestedArticle.slug);
                                        })
                                    })
                                }),
                                hasPostSuggestionSlider && /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexBox/* default */.Z, {
                                    alignItems: "center",
                                    ml: 5,
                                    mr: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        ml: 5,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideButton, {
                                            onClick: postSuggestionSlides.next,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
                                                fontSize: "large"
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        hasPostSuggestionSlider && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            mt: 3,
                            mb: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* default */.Z, {
                                count: postSuggestionSlides.pageCount,
                                activeIndex: postSuggestionSlides.pageIndex,
                                onClick: postSuggestionSlides.setPageIndex
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            mt: {
                                xs: 4,
                                md: 5
                            },
                            textAlign: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/hub",
                                passHref: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLink, {
                                    variant: "tertiary",
                                    component: "a",
                                    children: t("post.otherArticles")
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinks["default"], {
                pb: {
                    xs: 2,
                    sm: 6
                },
                pt: {
                    xs: 2,
                    sm: 3
                }
            })
        ]
    });
}
/**
 * STYLED COMPONENTS
 */ var ListWrapper = styled_components_browser_esm/* default.div */.ZP.div(ArticlePage_templateObject());
var ArrowBack = (0,styled_components_browser_esm/* default */.ZP)(ArrowForwardIos/* default */.Z)(ArticlePage_templateObject1());
var SlideButton = (0,styled_components_browser_esm/* default */.ZP)(ButtonBase/* default */.Z)(ArticlePage_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(4, 0);
}, function(param) {
    var theme = param.theme;
    return theme.palette.grey[200];
}, function(param) {
    var theme = param.theme;
    return theme.palette.grey[300];
});
var Anchor = styled_components_browser_esm/* default.a */.ZP.a(ArticlePage_templateObject3());
var ButtonLink = (0,styled_components_browser_esm/* default */.ZP)(esm/* Button */.zx)(ArticlePage_templateObject4(), function(props) {
    return props.theme.spacing(1, 2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
var TypographyAuthorDescription = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(ArticlePage_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary["400"];
});
var FooterCTA = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject6(), function(props) {
    return props.theme.spacing(8, 0);
}, function(props) {
    return props.theme.colors.heroGradient;
});
var SuggestedArticlesWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7(), function(props) {
    return props.theme.spacing(8, 0);
});
/* harmony default export */ var components_ArticlePage = (ArticlePage);

;// CONCATENATED MODULE: ./src/pages/hub/[category]/[slug].tsx




function HubPost(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArticlePage, (0,_object_spread/* default */.Z)({}, props));
}
var __N_SSG = true;
/* harmony default export */ var _slug_ = (HubPost);


/***/ }),

/***/ 90848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85444);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: ",
        "px;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border-radius: 50%;\n    flex-shrink: 0;\n    border: ",
        ";\n    padding: 0;\n    box-sizing: border-box;\n    transition: background-color 0.1s ease-out;\n    width: ",
        ";\n    height: ",
        ";\n\n    cursor: ",
        ";\n\n    &:hover: {\n      background-color: ",
        ";\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var Dots = function(param) {
    var count = param.count, activeIndex = param.activeIndex, onClick = param.onClick, _size = param.size, size = _size === void 0 ? "11px" : _size, _color = param.color, color = _color === void 0 ? "#E3E4E4" : _color, border = param.border, _activeColor = param.activeColor, activeColor = _activeColor === void 0 ? "#3C4340" : _activeColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: new Array(count).fill(1).map(function(_, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Dot, {
                as: onClick ? "button" : "div",
                type: "button",
                "aria-label": "select slide: ".concat(index + 1),
                onClick: onClick ? function() {
                    return onClick(index);
                } : undefined,
                $active: activeIndex === index,
                $size: size,
                $color: color,
                $activeColor: activeColor,
                $isButton: !!onClick,
                $border: border
            }, index);
        })
    });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .ZP.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var Dot = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .ZP.div(_templateObject2(), function(param) {
    var $active = param.$active, $size = param.$size, $activeColor = param.$activeColor, $color = param.$color, $isButton = param.$isButton, _$border = param.$border, $border = _$border === void 0 ? "none" : _$border;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), $active ? $activeColor : $color, $border, $size, $size, $isButton ? "pointer" : "auto", $isButton ? $activeColor : $color);
});
/* harmony default export */ __webpack_exports__["Z"] = (Dots);


/***/ }),

/***/ 85249:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65576);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85444);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: ",
        "px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Utility component with the same API as Box
 *
 * Differences:
 * - `display="flex"` is automatically applied.
 * - Accepts a `gap` property
 */ var FlexBox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) {
    var _display = _param.display, display = _display === void 0 ? "flex" : _display, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "display"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BoxWithGaps, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        display: display,
        ref: ref
    }, props));
});
FlexBox.displayName = "FlexBox";
var BoxWithGaps = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_templateObject(), function(param) {
    var gap = param.gap;
    return gap ? gap * 8 : 0;
});
/* harmony default export */ __webpack_exports__["Z"] = (FlexBox);


/***/ }),

/***/ 47004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eb": function() { return /* binding */ localeToDateLocaleMapping; },
/* harmony export */   "nz": function() { return /* binding */ toUnixTimestamp; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* unused harmony export getDayNameFromDate */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46216);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89345);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70879);


var dateFormatByLocaleMapping = {
    en: "dd/MM/yyyy",
    de: "dd.MM.yy",
    da: "dd/MM/yyyy",
    "da-dk": "dd/MM/yyyy",
    "en-uk": "dd/MM/yyyy",
    "en-de": "dd/MM/yyyy",
    "de-at": "dd.MM.yy",
    "de-ch": "dd.MM.yy",
    "de-de": "dd.MM.yy"
};
var localeToDateLocaleMapping = {
    en: date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    de: date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    da: date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    "da-dk": date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    "en-uk": date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    "en-de": date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    "de-at": date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    "de-ch": date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
    "de-de": date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
};
function formatDate(dateString, locale) {
    if (dateString === null || typeof dateString === "undefined") {
        return null;
    }
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(new Date(dateString), dateFormatByLocaleMapping[locale], {
        locale: localeToDateLocaleMapping[locale]
    });
}
function toUnixTimestamp(date) {
    return (date.getTime() / 1000).toFixed(0);
}
function getDayNameFromDate(date) {
    return date ? format(date, "EEEE").toLowerCase() : undefined;
}


/***/ }),

/***/ 98038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ usePagination; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/shared/helpers/array.ts
function chunk(array, length) {
    var chunks = [];
    var i = 0;
    var n = array.length;
    while(i < n){
        chunks.push(array.slice(i, i += length));
    }
    return chunks;
}

;// CONCATENATED MODULE: ./src/shared/hooks/usePagination.ts


var usePagination = function(items, param) {
    var pageSize = param.pageSize, initialPage = param.initialPage, limit = param.limit;
    var ref = (0,react.useState)(initialPage || 0), pageIndex = ref[0], setPageIndex = ref[1];
    var paginatedItems = (0,react.useMemo)(function() {
        return chunk(limit ? items.slice(0, limit) : items, pageSize);
    }, [
        items,
        limit,
        pageSize
    ]);
    var lastPageIndex = paginatedItems.length - 1;
    var next = (0,react.useCallback)(function() {
        return setPageIndex(function(prev) {
            return (prev + 1) % paginatedItems.length;
        });
    }, [
        pageSize
    ]);
    var prev = (0,react.useCallback)(function() {
        return setPageIndex(function(prev) {
            return prev - 1 === -1 ? lastPageIndex : prev - 1;
        });
    }, [
        pageSize
    ]);
    return {
        pages: paginatedItems,
        currentPage: paginatedItems[pageIndex],
        nextPage: paginatedItems[pageIndex + 1],
        prevPage: paginatedItems[pageIndex - 1],
        pageCount: paginatedItems.length,
        pageIndex: pageIndex,
        next: next,
        prev: prev,
        setPageIndex: setPageIndex
    };
};


/***/ }),

/***/ 6029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FooterLinks; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89659);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26793);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85444);
/* harmony import */ var system_components_Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10758);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









function FooterLinks(props) {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$)("static_pages").t;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var cities = [
        {
            key: "berlin",
            link: "berlin"
        },
        {
            key: "muenchen",
            link: "muenchen"
        },
        {
            key: "hamburg",
            link: "hamburg"
        },
        {
            key: "frankfurt-am-main",
            link: "frankfurt"
        },
        {
            key: "duesseldorf",
            link: "duesseldorf"
        },
        {
            key: "koeln",
            link: "koeln"
        },
        {
            key: "leipzig",
            link: "leipzig"
        },
        {
            key: "hannover",
            link: "hannover"
        }, 
    ];
    var countries = [
        "austria",
        "germany",
        "switzerland"
    ];
    var countriesLinksMapping = {
        switzerland: "schweiz",
        germany: "deutschland",
        austria: "oesterreich"
    };
    var cateringCategories = [
        {
            key: "fingerfood",
            url: "/fingerfood"
        },
        {
            key: "breakfast",
            url: "/fruehstueck"
        },
        {
            key: "foodTruck",
            url: "/food-truck"
        },
        {
            key: "event",
            url: "/event"
        },
        {
            key: "buffet",
            url: "/buffet"
        },
        {
            key: "cocktail",
            url: "/bar-cocktail"
        },
        {
            key: "coffee",
            url: "/mobile-kaffeebar"
        },
        {
            key: "vegan",
            url: "/vegan"
        },
        {
            key: "bbq",
            url: "/grill-catering"
        },
        {
            key: "summer_party",
            url: "/sommerfest"
        },
        {
            key: "company_party",
            url: "/catering-firmenfeier"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(system_components_Container__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        as: "nav"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
            pb: 2,
            pt: 4,
            id: "footerLinksSection",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                            variant: "h6",
                            component: "h6",
                            mb: 3,
                            children: t("footerLinks.cateringCategories")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            pl: 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGrid, {
                                container: true,
                                spacing: 1,
                                children: cateringCategories.map(function(category) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        item: true,
                                        md: 3,
                                        sm: 6,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/".concat(router.locale).concat(category.url),
                                            passHref: true,
                                            locale: false,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                color: "textPrimary",
                                                children: t("footerLinks.categories.".concat(category.key))
                                            })
                                        })
                                    }, category.key);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                            variant: "h6",
                            component: "h6",
                            mt: 5,
                            mb: 3,
                            children: t("footerLinks.cities")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            pl: 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGrid, {
                                container: true,
                                spacing: 1,
                                children: cities.map(function(city) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        item: true,
                                        md: 3,
                                        sm: 6,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/".concat(router.locale, "/catering-").concat(city.link),
                                            passHref: true,
                                            locale: false,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                color: "textPrimary",
                                                children: t("footerLinks.cateringIn", {
                                                    city: t("common:cities.".concat(city.key))
                                                })
                                            }, city.key)
                                        })
                                    }, city.link);
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                            variant: "h6",
                            component: "h6",
                            mt: 5,
                            mb: 3,
                            children: t("footerLinks.countries")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                            pl: 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledGrid, {
                                container: true,
                                spacing: 1,
                                children: countries.map(function(country) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        item: true,
                                        md: 3,
                                        sm: 6,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                            href: "/".concat(router.locale, "/catering-").concat(countriesLinksMapping[country]),
                                            passHref: true,
                                            locale: false,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                variant: "body2",
                                                color: "textPrimary",
                                                children: t("common:countries.".concat(country))
                                            }, country)
                                        })
                                    }, country);
                                })
                            })
                        })
                    ]
                })
            ]
        })
    }));
}
var StyledGrid = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_templateObject(), function(props) {
    return props.theme.spacing(0, 0, 0, 1);
});


/***/ }),

/***/ 84332:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ AreaWithSidebarCTA; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95197);
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39138);
/* harmony import */ var lodash_truncate__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_truncate__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26793);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70131);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85444);
/* harmony import */ var shared_components_FlexBox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85249);
/* harmony import */ var shared_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98769);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: currentColor;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 100%;\n  font-size: 14px;\n  text-decoration: none;\n  text-align: center;\n  display: block;\n  white-space: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var TOP_OFFSET = 170;
var PAGE_CONTENT_WIDTH = "720px";
var CTA_IMAGE_NEGATIVE_MARGIN = 8;
var Sidebar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(param, ref) {
    var title = param.title, subtitle = param.subtitle, ctaText = param.ctaText, url = param.url, isVisible = param.isVisible, _width = param.width, width = _width === void 0 ? 230 : _width, _rightPadding = param.rightPadding, rightPadding = _rightPadding === void 0 ? "40px" : _rightPadding;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)("static_pages").t;
    var ctaButtonText = lodash_truncate__WEBPACK_IMPORTED_MODULE_4___default()(ctaText ? ctaText : t("marketingPages.sidebar.cta"), {
        length: 100
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(CTAWrapperBox, {
        as: "aside",
        ref: ref,
        borderRadius: "8px",
        visibility: isVisible ? "visible" : "hidden",
        position: "fixed",
        top: TOP_OFFSET + CTA_IMAGE_NEGATIVE_MARGIN * SPACING_MULTIPLIER,
        pb: 2,
        left: "calc((100vw - ".concat(PAGE_CONTENT_WIDTH, ") / 2 - ").concat(width, "px - ").concat(rightPadding, ")"),
        width: width,
        display: {
            xs: "none",
            lg: "block"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                mt: -CTA_IMAGE_NEGATIVE_MARGIN,
                textAlign: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                    alt: "",
                    src: "/artifacts/images/marketing_pages/catering_cta_image.webp",
                    height: 162,
                    width: 199
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                variant: "h2",
                component: "h3",
                align: "center",
                px: 2,
                mt: 2,
                fontSize: "24px",
                children: title ? title : t("marketingPages.sidebar.title")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                variant: "body1",
                mt: 3,
                px: 2,
                align: "center",
                fontWeight: "500",
                mb: 3,
                children: subtitle ? subtitle : t("marketingPages.sidebar.body")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(shared_components_FlexBox__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                alignItems: "center",
                flexDirection: "column",
                px: 2,
                mt: 2,
                gap: 2,
                children: [
                    url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                        as: "a",
                        size: "lg",
                        rounded: true,
                        href: url,
                        id: "sidebar-cta",
                        mt: 2,
                        children: ctaButtonText
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
                        rounded: true,
                        size: "lg",
                        onClick: function() {
                            return window.scroll({
                                top: 0,
                                behavior: "smooth"
                            });
                        },
                        id: "sidebar-cta",
                        children: ctaButtonText
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PhoneLink, {
                        href: shared_constants__WEBPACK_IMPORTED_MODULE_7__/* .CONTACT_PHONE.href */ .Y.href,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                            fontSize: "12px",
                            children: shared_constants__WEBPACK_IMPORTED_MODULE_7__/* .CONTACT_PHONE.formatted */ .Y.formatted
                        })
                    })
                ]
            })
        ]
    });
});
Sidebar.displayName = "Sidebar";
var SPACING_MULTIPLIER = 8;
var PhoneLink = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].a */ .ZP.a(_templateObject());
var CTAWrapperBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu)(_templateObject1(), function(props) {
    return props.theme.colors.heroGradient;
});
/**
 * Wraps an area, where the sidebar will be shown.
 */ var AreaWithSidebarCTA = function(param) {
    var children = param.children, title = param.title, subtitle = param.subtitle, ctaText = param.ctaText, url = param.url, _topPadding = param.topPadding, topPadding = _topPadding === void 0 ? 2 : _topPadding, _bottomPadding = param.bottomPadding, bottomPadding = _bottomPadding === void 0 ? 5 : _bottomPadding;
    var ref, ref1;
    var ref2 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_10__/* .useInView */ .YD)({
        threshold: 1
    }), startRef = ref2.ref, startEntry = ref2.entry;
    var ref3 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_10__/* .useInView */ .YD)({
        threshold: 1
    }), endRef = ref3.ref, endEntry = ref3.entry;
    var startNodePosition = getNodePosition(startEntry);
    var endNodePosition = getNodePosition(endEntry);
    var isBetweenPoints = startNodePosition === "over-viewport" && endNodePosition === "under-viewport";
    var sidebarRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var sidebarBottom = (ref1 = (ref = sidebarRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect()) === null || ref1 === void 0 ? void 0 : ref1.bottom;
    var bottomOffset =  true ? window.innerHeight - sidebarBottom : 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                position: "relative",
                top: "-".concat(TOP_OFFSET - topPadding * SPACING_MULTIPLIER, "px"),
                ref: startRef
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Sidebar, {
                ref: sidebarRef,
                isVisible: isBetweenPoints,
                title: title,
                subtitle: subtitle,
                ctaText: ctaText,
                url: url
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                position: "relative",
                bottom: "-".concat(bottomOffset - bottomPadding * SPACING_MULTIPLIER, "px"),
                ref: endRef
            })
        ]
    });
};
var StyledButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx)(_templateObject2());
function getNodePosition(observerEntry) {
    if (!(observerEntry === null || observerEntry === void 0 ? void 0 : observerEntry.rootBounds)) {
        return;
    }
    if (observerEntry.isIntersecting) {
        return "in-viewport";
    } else {
        if (observerEntry.boundingClientRect.top > observerEntry.rootBounds.bottom) {
            return "under-viewport";
        } else {
            return "over-viewport";
        }
    }
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1664,7879,9433,2311,7766,8184,1507,4566,4872,9743,3992,8522,4254,3704,7516,9774,2888,179], function() { return __webpack_exec__(58670); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);